import Vue from "vue"
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
	namespaced: true,
	state: {
		nav: [],
		searchKey: "", // 公共头部的搜索

		studentID: "2", // 学生会员id
		rememberLoginStatus: true, // 记住登录
		showLoginPop: false, // 是否显示登录弹框
		isLogin: false, // 记录是否登录
		token: localStorage.getItem("token") || '',
		userInfo: { // 用户信息
			name: '',
			id: ''
		},
		commodityInfo: {}, // 完善个人信息后选择需要注册会员类型时保存的商品信息
	},
	
	mutations: {
		set_login_status(state, data) {
			state.isLogin = data;
		},
		set_user_info(state, data) {
			state.userInfo = data
		},
		set_token(state, data) {
			state.token = data;
			// 记住登录true时，缓存token至localStorage中
			if (state.rememberLoginStatus) {
				localStorage.setItem("token", data)
			} else {
				localStorage.removeItem("token")
			}
		},
		set_nav(state, data) {
			state.nav = data
		},
		set_searchKey(state, data) {
			state.searchKey = data
		},
		set_show_login_pop(state, data) {
			state.showLoginPop = data
		},
		set_commodity_info(state, data) {
			state.commodityInfo = data
		},
		set_remember_login_status(state, data) {
			state.rememberLoginStatus = data
		}
	},
	
	actions: {
		setLoginStatus({commit}, data) {
			commit('set_login_status', data)
		},
		setUserInfo({commit}, data) {
			commit('set_user_info', data)
		},
		setToken({commit}, data) {
			commit('set_token', data)
		},
		setNav({commit}, data) {
			commit('set_nav', data)
		},
		setSearchKey({commit}, data) {
			commit('set_searchKey', data)
		},
		// 登录注册框显示隐藏设置
		setShowLoginPop({commit}, data) {
			commit('set_show_login_pop', data)
		},
		// 设置购买的商品信息
		setCommodityInfo({commit}, data) {
			commit('set_commodity_info', data)
		}
	}
})
